import { Link } from 'react-router-dom';
import { Check, X } from 'lucide-react';

export default function ComoTrabalhoPage() {
  const whatItIs = [
  'Conversa orientada com propósito definido',
  'Análise cognitiva de padrões de pensamento',
  'Escrita e registo estruturado',
  'Construção de sistemas de decisão',
  'Acompanhamento adaptado ao momento de vida',
  'Espaço de clarificação, não de motivação'];


  const whatItIsNot = [
  'Terapia ou aconselhamento psicológico',
  'Coaching motivacional ou inspiracional',
  'Assistência executiva ou gestão de tarefas',
  'Mentoria baseada em experiência de setor',
  'Consultoria de negócios tradicional',
  'Disponibilidade ilimitada ou acesso constante'];


  return (
    <main className="pt-24" data-testid="como-trabalho-page">
      {/* Hero */}
      <section className="section">
        <div className="page-container">
          <div className="max-w-3xl">
            <span className="label-mono mb-4 block">Abordagem</span>
            <h1 className="heading-display mb-8">
              Como Trabalho
            </h1>
            <p className="body-text text-lg !mr-[150px]">O trabalho assenta em conversa orientada, não em frameworks rígidos. Cada pessoa traz um contexto único e a abordagem adapta-se a esse contexto, não o contrário.



            </p>
          </div>
        </div>
      </section>

      {/* Approach */}
      <section className="section section-muted" data-testid="approach-section">
        <div className="page-container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24">
            <div>
              <span className="label-mono mb-4 block">Fundamentos</span>
              <h2 className="heading-section mb-6">
                Quatro pilares de trabalho
              </h2>
            </div>
            
            <div className="space-y-12">
              <div>
                <h3 className="font-serif text-xl mb-3">Conversa Orientada</h3>
                <p className="body-text">
                  Não é conversa livre. Cada sessão tem um propósito claro, 
                  mesmo quando o caminho para lá chegar não é linear. 
                  O objetivo é sempre clarificar, nunca preencher tempo.
                </p>
              </div>

              <div>
                <h3 className="font-serif text-xl mb-3">Análise Cognitiva</h3>
                <p className="body-text">
                  Identificação de padrões de pensamento, crenças implícitas 
                  e estruturas mentais que condicionam decisões. 
                  Tornar visível o que normalmente opera em segundo plano.
                </p>
              </div>

              <div>
                <h3 className="font-serif text-xl mb-3">Escrita e Registo</h3>
                <p className="body-text">
                  O pensamento que não é registado raramente evolui. 
                  A escrita estruturada é ferramenta de clarificação, 
                  não apenas de documentação.
                </p>
              </div>

              <div>
                <h3 className="font-serif text-xl mb-3">Sistemas de Decisão</h3>
                <p className="body-text">
                  Construção de estruturas que permitam tomar melhores decisões 
                  de forma consistente, reduzindo a dependência de motivação 
                  ou força de vontade.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What It Is / What It Is Not */}
      <section className="section" data-testid="what-it-is-section">
        <div className="page-container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
            {/* What It Is */}
            <div>
              <span className="label-mono mb-4 block">Definição</span>
              <h2 className="heading-section mb-8">
                O que este acompanhamento é
              </h2>
              <ul className="space-y-4">
                {whatItIs.map((item, index) =>
                <li key={index} className="flex items-start gap-4">
                    <span className="mt-1 flex-shrink-0">
                      <Check size={18} className="text-[#1A1A1A]" />
                    </span>
                    <span className="body-text">{item}</span>
                  </li>
                )}
              </ul>
            </div>

            {/* What It Is Not */}
            <div>
              <span className="label-mono mb-4 block">Limites</span>
              <h2 className="heading-section mb-8">
                O que este acompanhamento não é
              </h2>
              <ul className="space-y-4">
                {whatItIsNot.map((item, index) =>
                <li key={index} className="flex items-start gap-4">
                    <span className="mt-1 flex-shrink-0">
                      <X size={18} className="text-[#5A5A5A]" />
                    </span>
                    <span className="body-text">{item}</span>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Responsibility */}
      <section className="section section-muted" data-testid="responsibility-section">
        <div className="page-container">
          <div className="max-w-2xl">
            <span className="label-mono mb-4 block">Princípio</span>
            <h2 className="heading-section mb-6">
              A responsabilidade final é sempre sua.
            </h2>
            <p className="body-text mb-6">
              Todos os níveis de acompanhamento são completos em si mesmos. 
              Não existe um "melhor" ou "mais avançado" — existe o adequado 
              para o momento e a necessidade.
            </p>
            <p className="body-text">
              O meu papel é criar condições para clareza. 
              As decisões, a implementação e os resultados 
              são responsabilidade de quem os toma.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section">
        <div className="page-container">
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/acompanhamentos" className="btn-primary" data-testid="cta-services">
              Ver Acompanhamentos
            </Link>
            <Link to="/processo" className="btn-outline" data-testid="cta-process">
              Como Começar
            </Link>
          </div>
        </div>
      </section>
    </main>);

}